export const ACTIONS = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
};
